export enum ApiConstantHcBase {
  ASSESSMENT = 'assessments/api',
  MASTER = 'master/api',
}

export enum ApiConstantHc {
  // WEBPAGE - CERTIFICATION
  CERTIFICATION_URL = 'certifications',

  // WEBPAGE - CERTIFICATION REGISTRATION - PROCESS DATE
  CERTIFICATION_REGISTRATION_PROCESS_DATE_URL = 'certifications/registration/processDate',

  // WEBPAGE - CERTIFICATION REGISTRATION - PERSONAL DATA
  CERTIFICATION_REGISTRATION_PERSONAL_DATA_URL = 'certifications/registration/personalData',

  // WEBPAGE - CERTIFICATION REGISTRATION - PURPOSE OF ASSESSMENT
  CERTIFICATION_REGISTRATION_PURPOSE_OF_ASSESSMENTS_URL = 'certifications/registration/purposeOfAssessment',

  // WEBPAGE - CERTIFICATION REGISTRATION - PRECONDITION GENERAL PROOF
  CERTIFICATION_REGISTRATION_PRECONDITION_GENERAL_PROOF_URL = 'certifications/registration/precondition/generalProof',

  // WEBPAGE - CERTIFICATION REGISTRATION - PRECONDITION RELEVANT PROOF
  CERTIFICATION_REGISTRATION_PRECONDITION_RELEVANT_PROOF_URL = 'certifications/registration/precondition/relevantProof',

  // WEBPAGE - CERTIFICATION REGISTRATION - PRECONDITION SUPPORT DOCUMENT
  CERTIFICATION_REGISTRATION_PRECONDITION_SUPPORT_DOCUMENT_URL = 'certifications/registration/precondition/supportDocument',

  // WEBPAGE - CERTIFICATION REGISTRATION - SELF ASSESSMENT
  CERTIFICATION_REGISTRATION_SELF_ASSESSMENT_URL = 'certifications/registration/selfAssessment',

  // WEBPAGE - CERTIFICATION REGISTRATION - FINAL
  CERTIFICATION_REGISTRATION_FINAL = 'certifications/registration/final',

  // BACK OFFICE - PROFILE
  PROFILE_URL = 'profile',

  // BACK OFFICE - ASSESSMENT
  ASSESSMENT_URL = 'assessments',

  // BACK OFFICE - DECISION

  CMS_DECISION_URL = 'cms',

  // BACK OFFICE - ASSESSMENT - REGISTRATION - GENERAL PROOF
  ASSESSMENT_REGISTRATION_GENERAL_PROOF_URL = 'assessments/registration/generalProofs',

  // BACK OFFICE - ASSESSMENT - REGISTRATION - RELEVANT PROOF
  ASSESSMENT_REGISTRATION_RELEVANT_PROOF_URL = 'assessments/registration/relevantProofs',

  // BACK OFFICE - ASSESSMENT - REGISTRATION - RELEVANT PROOF
  ASSESSMENT_REGISTRATION_ADMINISTRATIVE_PROOF_URL = 'assessments/registration/administrative',

  // BACK OFFICE - ASSESSMENT - REGISTRATION - COMPETENCY UNIT
  ASSESSMENT_REGISTRATION_COMPETENCY_UNIT_URL = 'assessments/registration/competencyUnits',

  // BACK OFFICE - ASSESSMENT - PLANNING
  ASSESSMENT_PLANNING_URL = 'assessments/planning',

  // BACK OFFICE - ASSESSMENT - PREPARATION
  ASSESSMENT_PREPARATION_URL = 'assessments/preparation',

  //UPLOAD DOCUMENT
  UPLOAD_DOC_ASSESSMENT_PHASE = 'uploadDocument',

  // BACK OFFICE - ASSESSMENT - PREPARATION - COMMENT
  ASSESSMENT_PREPARATION_COMMENT_URL = 'assessments/preparation/comments',

  // BACK OFFICE - ASSESSMENT - ANOTHER DOCUMENT
  ASSESSMENT_ANOTHER_DOCUMENT_URL = 'assessments/anotherDocuments',
}

export enum ApiConstant {
  // BASE
  BACK_OFFICE = 'backOffice',
  WEBPAGE = 'webpage',
  WEBPAGE_URL = 'lspbe_cms/api',
  BACK_OFFICE_URL = 'lspbe_bo/api',

  // WEBPAGE
  HOME_URL = 'home',
  ABOUT_US_URL = 'aboutUs',
  CERTIFICATION_URL = 'certifications',
  ASSESSOR_URL = 'assessors',
  TUK_URL = 'tuk',
  GALLERY_URL = 'galleries',
  CONTACT_US_URL = 'contactUs',
  SUBMIT_CONTACT_US_URL = 'contactUs/submit',
  NEWS_URL = 'news',

  // Profile
  PROFILE_URL = 'profile',

  // AUTH
  AUTH_URL = 'auth',

  // OTP
  OTP_URL = 'otp',

  // PROFILE
  MY_DOCUMENT_URL = 'myDocuments',
  ADDITIONAL_QUESTION = 'personal-additional-question',

  // QA
  QA_URL = 'qa',

  // USER
  USER_URL = 'users',

  // MASTER
  MASTER_COMPANY_URL = 'company',
  MASTER_BRANCH_URL = 'branch',
  MASTER_DIVISION_URL = 'division',
  MASTER_ROLE_URL = 'roles',
  MASTER_FIELD_URL = 'certificationFields',
  MASTER_CERTIFICATION_SCHEMA_URL = 'certificationSchemas',
  MASTER_CERTIFICATION_SCHEMA_FIELD_URL = 'certificationFieldsSchemas',
  MASTER_TUK_TYPE_URL = 'tukTypes',
  MASTER_TUK_URL = 'tuk',
  MASTER_TUK_TUK_TYPE_URL = 'tukTukTypes',
  MASTER_CATEGORY_URL = 'category',
  MASTER_PROGRAM_TYPE_URL = 'programTypes',
  MASTER_DOCUMENT_PROOF_URL = 'documentProofs',
  MASTER_DOCUMENT_DETAIL_URL = 'documentDetails',

  // USER ACCESS
  USER_ACCESS_URL = 'userAccesses',

  // CONTENT MANAGEMENT
  CONTENT_HOME_BANNER_URL = 'api://home-banner',
  CONTENT_HOME_WELCOME_URL = 'contents/home/welcome/items',
  CONTENT_HOME_CERTIFICATION_AGENCY_URL = 'contents/home/certificationAgencies',
  CONTENT_HOME_NEWS_URL = 'contents/home/news/items',
  CONTENT_GALLERY_URL = 'contents/galleries',
  CONTENT_ASSESSOR_URL = 'contents/assessor',
  CONTENT_TUK_URL = 'contents/tuk',

  // CONTENT MANAGEMENT - CERTIFICATION
  CONTENT_CERTIFICATION_SCHEMA_URL = 'contents/certification/schema/items',
  CONTENT_CERTIFICATION_REQUIREMENT_URL = 'contents/certification/requirement/items',
  CONTENT_CERTIFICATION_PROCESS_URL = 'contents/certification/process/items',
  CONTENT_CERTIFICATION_PROCEDURE_URL = 'contents/certification/procedure/items',
  CONTENT_CERTIFICATION_PARTICIPATED_INDUSTRIES_URL = 'contents/certification/participatedIndustries/items',

  // CONTENT MANAGEMENT - ABOUT US
  CONTENT_ABOUT_US_PROFILE_URL = 'contents/aboutUs/profile/items',
  CONTENT_ABOUT_US_DUTY_URL = 'contents/aboutUs/duty/items',
  CONTENT_ABOUT_US_MOTTO_URL = 'api//about-us-motto',
  CONTENT_ABOUT_US_VISION_URL = 'contents/aboutUs/vision/items',
  CONTENT_ABOUT_US_MISSION_URL = 'contents/aboutUs/mission/items',
  CONTENT_ABOUT_US_WORK_CULTURE_URL = 'api//about-us-work-culture',
  CONTENT_ABOUT_US_FOUNDER_URL = 'api//about-us-founder',
  CONTENT_ABOUT_US_STRUCTURE_URL = 'contents/aboutUs/structure/items',
  CONTENT_ABOUT_US_AUTHORITY_URL = 'contents/aboutUs/authority/items',
  CONTENT_ABOUT_US_TRANSFORMATION_URL = 'contents/aboutUs/transformation/items',

  // CONTENT MANAGEMENT - CONTACT US
  CONTENT_CONTACT_US_URL = 'contents/contactUs',

  // CERTIFICATE SUBMISSION STATUS
  CERTIFICATE_SUBMISSION_STATUS_URL = 'certificateSubmissionStatus',

  // SET SELF ASSESSMENT FORM
  SET_SELF_ASSESSMENT_FORM_URL = 'setSelfAssessmentForms',
  SET_SELF_ASSESSMENT_FORM_PRECONDITION_FORM = 'setSelfAssessmentForm/preconditionForms',

  // APPROVAL CERTIFICATION SCHEMA
  APPROVAL_CERTIFICATION_SCHEMA_URL = 'approvalCertificationSchemas',

  // ANTI FORGERY
  ANTI_FORGERY = 'antiforgery',

  // ASSESSMENT
  ASSESSMENT_SUPPORT_DOCUMENT_URL = 'assessments/supportDocuments',
}

export enum ApiSuccessConstant {
  OK = 'ok',
  CREATED = 'created',
}

export enum ApiFailedConstant {
  TIMEOUT = 'timeout',
  CANNOT_CONNECT = 'cannot-connect',
  SERVER = 'server',
  SERVICE_UNAVAILABLE = 'service-unavailable',
  BAD_GATEWAY = 'bad-gateway',
  INTERNAL_SERVER_ERROR = 'internal-server-error',
  UNAUTHORIZED = 'unauthorized',
  FORBIDDEN = 'forbidden',
  NOT_FOUND = 'not-found',
  REJECTED = 'rejected',
  UNKNOWN = 'unknown',
  BAD_DATA = 'bad-data',
  BAD_REQUEST = 'bad-request',
  CANCEL_ERROR = 'cancel-error',
  NETWORK_ERROR = 'network-error',
}
